/*
 * Authors: mariushirjanu
 * Created: 16/02/2022
 */
import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { TranslationService } from '../../translation/translation.service';

@Component({
  selector: 'link-addon',
  template: `
    <a [attr.href]="href" target="_blank" [class]="linkClass" [attr.disabled]="disabled() ? 'disabled' : null"><i *ngIf="icon" class="fa {{icon}}">&nbsp;</i>{{label | translate}}</a>
  `
})
export class LinkAddonComponent implements OnChanges {
  @Input() public href:string;
  @Input() public label?:string;
  @Input() public icon?:string;
  @Input() public linkClass?:string;
  @Input() public disabled?:Function;

  constructor(
    private translationService:TranslationService
  ) {
    /***/
  }

  public ngOnChanges(changesObj:SimpleChanges):void {
    if (changesObj.label) {
      this.label = this.translationService.instant(changesObj.label.currentValue);
    }
  }
}